import { IconsProps } from '@/types/shared'

const FolderIcons: React.FC<IconsProps> = (props) => {
    return (
        <div
            {...props}
            className={`flex items-center justify-center w-full h-full`}
        >
            <svg
                viewBox="0 0 93 75"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M9.50006 74.0268C6.95631 74.0268 4.77871 73.1211 2.96725 71.3097C1.15579 69.4982 0.250061 67.3206 0.250061 64.7768V9.27685C0.250061 6.7331 1.15579 4.5555 2.96725 2.74404C4.77871 0.932584 6.95631 0.0268555 9.50006 0.0268555H37.2501L46.5001 9.27685H83.5001C86.0438 9.27685 88.2214 10.1826 90.0329 11.994C91.8443 13.8055 92.7501 15.9831 92.7501 18.5269V64.7768C92.7501 67.3206 91.8443 69.4982 90.0329 71.3097C88.2214 73.1211 86.0438 74.0268 83.5001 74.0268H9.50006Z"
                    fill="#BABDD8"
                />
            </svg>
        </div>
    )
}

export default FolderIcons
